//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getRewardList } from '@/api/my.js'
export default {
  data () {
    return {
        title: '贡献排行',
        topList: [],
        list: [
        ]
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    getList () {
      getRewardList({
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        this.topList = res.data.list.slice(0, 3)
        this.list = res.data.list.slice(3, res.data.list.length)
      })
    }
  },
  created () {
    this.getList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/Mine/consume.vue